import DataTable from "datatables.net-react";
import { Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';


function multiledger() {
    return (
        <Card className='mt-2'>
            <Card.Body>
                
                    <Col >
                        <Button variant="secondary " size="sm">View Report</Button>
                    </Col>

                        <Col></Col>
                        <Col></Col>
                        <Col></Col>

                                                
                

                <DataTable striped bordered hover className='mt-2' >
        <thead>
        <tr >
          <th className='bg-secondary fss-05'>
            {['checkbox'].map((type) => (   
                    <Form.Check
                      inline
                      name="group1"
                      type={type}
                      variant="light"
                      id={`inline-${type}-1`}
                      
                    />   
                ))}
                
        </th>
          <th  className='bg-secondary fss-05' > CODE</th>
          <th  className='bg-secondary fss-05' >NAME</th>
          <th  className='bg-secondary fss-05' >CREDIT</th>
          <th  className='bg-secondary fss-05' >DEBIT</th>

        </tr>
      </thead>
      <tbody>

        </tbody>
    </DataTable>
    
            </Card.Body>
        </Card>
    );
}

export default multiledger;